import {
  useCurrentUserLocale,
  useCurrentUserTimezone,
} from "@linkfluence/core/user/use-cases";
import { Interval } from "@linkfluence/models/date";
import { useContextualWorkspaceMilestones } from "@radarly/core/context/use-cases";
import { useFeature } from "@radarly/core/features/use-cases";
import { useProject } from "@radarly/core/project/context";
import { WizardConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";
import { getProjectLimits } from "@radarly/models/project";

export function useWizardPeriodSelector({
  configuration,
}: {
  configuration: WizardConfiguration;
}) {
  const timezone = useCurrentUserTimezone();
  const milestones = useContextualWorkspaceMilestones();
  const enabledMilestones = useFeature("period_selector_milestones");
  const locale = useCurrentUserLocale();
  const project = useProject();
  return {
    milestones: !enabledMilestones ? [] : milestones,
    limits: getProjectLimits(project, Interval.Day),
    timezone: configuration.timezone || timezone,
    locale,
  };
}
